<h2 mat-dialog-title>PDF Name</h2>
<mat-dialog-content style="padding-bottom: 0px;overflow: hidden;">
    <div style="width:450px;padding-bottom: 0px;overflow: hidden;">
        <div style="padding-bottom: 10px;">
            <p *ngIf="V10">Shown below is the default name for the copy of this form which will be saved as a PDF in Student Digital Content.</p>
            <p *ngIf="!V10">Shown below is the default name for the copy of this form which will be saved as a PDF in Student Documents.</p>
            <p>Because multiple copies of this form may be submitted, you may wish to change the name to something less
                generic so it is easier to distinguish between the copies.</p>
        </div>
        <tyl-form-field label='PDF Name' style="width:450px;">
            <input #nameRef matInput id='inpPDFName' type='text' [(ngModel)]='PDFName'
                name="name" />
        </tyl-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class='flex-footer-left'>
    </div>
    <div class='flex-footer-right'>        
        <tyl-button image="next arrow.png" label="Continue" (clickEvent)="nextClick()"></tyl-button>        
    </div>
</mat-dialog-actions>
